import React from "react";
var VgWortPixel = function VgWortPixel(_ref) {
    var pixel = _ref.pixel;
    if (pixel && pixel.domain && pixel.publicIdentificationId) {
        var url = "https://" + pixel.domain + "/na/pw-" + pixel.publicIdentificationId;
        return /*#__PURE__*/ React.createElement("img", {
            alt: "",
            src: url,
            height: "1",
            width: "1"
        });
    }
    return null;
};
export default VgWortPixel;
